export default __webpack_public_path__ + "static/media/MugCupProductInfo.9845482f.jpg";